import {
  PostOption,
  SectionPostOptions,
  Module,
} from '../../../../helpers/types'

/* getMomentModule takes a post component's post options and converts them to a dynamic module Component */
export default function getMomentModule(
  sectionPostOptions: SectionPostOptions,
  module: Module
): SectionPostOptions {
  if (module.componentName === 'twitter_moment_retweet') {
    return {
      refreshedAt: sectionPostOptions.twitterMomentRetweetRefreshedAt || '',
      retweetUrl: sectionPostOptions.twitterMomentRetweetRetweetUrl || '',
      snapshotUrl: sectionPostOptions.twitterMomentRetweetSnapshotUrl || '',
    }
  } else if (module.componentName === 'twitter_moment_poll') {
    return {
      pollOptionNumber:
        parseInt(
          (module.twitterMomentPollOptionNumber as PostOption)?.selected
            ?.title || '',
          10
        ) || 2,
      pollOne: sectionPostOptions.twitterMomentPollOne || '',
      pollTwo: sectionPostOptions.twitterMomentPollTwo || '',
      pollThree: sectionPostOptions.twitterMomentPollThree || '',
      pollFour: sectionPostOptions.twitterMomentPollFour || '',
    }
  } else if (module.componentName === 'twitter_moment_live_tweet') {
    return {
      refreshedAt: sectionPostOptions.twitterMomentLiveTweetRefreshedAt || '',
      snapshotUrl: sectionPostOptions.twitterMomentLiveTweetSnapshotUrl || '',
      tweetUrl: sectionPostOptions.twitterMomentLiveTweetTweetUrl || '',
    }
  } else {
    return {}
  }
}
